import { Component, Input, Output, EventEmitter, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'input-box',
  templateUrl: './input-box.component.html',
  styleUrls: ['./input-box.component.css']
})
export class InputBoxComponent implements OnInit, OnChanges {

  @Input() inputBoxData: any;
  @Input() selectedValues: any;
  /** When true, only numeric entry; paste is sanitized. */
  @Input() numericOnly = false;
  /** When true with numericOnly, allow a single decimal point (e.g. amounts, km). */
  @Input() allowDecimal = true;
  @Output() selectedText: EventEmitter<any> = new EventEmitter<any>();
  public enteredText: string;

  ngOnInit() {
    this.applySelectedValues();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedValues'] || changes['numericOnly'] || changes['allowDecimal']) {
      this.applySelectedValues();
    }
  }

  private applySelectedValues() {
    if (this.selectedValues != null && this.selectedValues !== '') {
      const s = String(this.selectedValues);
      this.enteredText = this.numericOnly ? this.sanitize(s) : s;
    } else if (this.selectedValues === '' || this.selectedValues === null || this.selectedValues === undefined) {
      this.enteredText = '';
    }
  }

  private sanitize(raw: string): string {
    if (!this.allowDecimal) {
      return raw.replace(/\D/g, '');
    }
    const cleaned = raw.replace(/[^\d.]/g, '');
    const firstDot = cleaned.indexOf('.');
    if (firstDot === -1) {
      return cleaned;
    }
    return cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, '');
  }

  onKeyDown(event: KeyboardEvent): void {
    if (!this.numericOnly) {
      return;
    }
    const key = event.key;
    const allowedNav = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'
    ];
    if (allowedNav.indexOf(key) >= 0) {
      return;
    }
    if (event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }
    if (/^[0-9]$/.test(key)) {
      return;
    }
    if (this.allowDecimal && key === '.') {
      const input = event.target as HTMLInputElement;
      const cur = this.enteredText != null ? String(this.enteredText) : '';
      const start = input.selectionStart != null ? input.selectionStart : cur.length;
      const end = input.selectionEnd != null ? input.selectionEnd : cur.length;
      const hypothetical = cur.substring(0, start) + '.' + cur.substring(end);
      if (hypothetical.split('.').length <= 2) {
        return;
      }
    }
    event.preventDefault();
  }

  onPaste(event: ClipboardEvent): void {
    if (!this.numericOnly) {
      return;
    }
    event.preventDefault();
    const pasted = (event.clipboardData && event.clipboardData.getData('text')) || '';
    const input = event.target as HTMLInputElement;
    const cur = this.enteredText != null ? String(this.enteredText) : '';
    const start = input.selectionStart != null ? input.selectionStart : cur.length;
    const end = input.selectionEnd != null ? input.selectionEnd : cur.length;
    const merged = cur.substring(0, start) + pasted + cur.substring(end);
    this.enteredText = this.sanitize(merged);
    setTimeout(() => {
      const len = this.enteredText ? this.enteredText.length : 0;
      input.setSelectionRange(len, len);
      this.emitValue();
    }, 0);
  }

  emitValue() {
    if (!this.inputBoxData || !this.inputBoxData.key) {
      return;
    }
    let value = this.enteredText;
    if (this.numericOnly && value != null && value !== '') {
      value = this.sanitize(String(value));
      if (value !== this.enteredText) {
        this.enteredText = value;
      }
    }
    const emitData = {};
    emitData[this.inputBoxData.key] = value;
    this.selectedText.emit(emitData);
  }

}
